<template>
  <app-widget :title="$t('common.filter')">
    <v-form slot="widget-content">
      <v-row cols="12">
        <v-col 
          xl="6"
          lg="6"
          md="6"
          sm="6"
          cols="12">
          <v-text-field
            data-cy="name"
            @input="updateFilterDebounce"
            v-model="filter.name"
            :rules="validationRules.name"
            :label="$t('device.fields.name')"
            required />
        </v-col>

        <v-col 
          xl="6"
          lg="6"
          md="6"
          sm="6"
          cols="12">
          <v-text-field
            data-cy="imei"
            @input="updateFilterDebounce"
            v-model="filter.imei"
            :rules="validationRules.imei"
            :label="$t('device.fields.imei')"
            required />
        </v-col>

        <v-col 
          xl="6"
          lg="6"
          md="6"
          sm="6"
          cols="12">
          <v-select
            data-cy="deviceStatus"
            @change="updateFilter"
            v-model="filter.deviceStatusType"
            value=""
            :items="deviceStatusTypes"
            :label="$t('device.fields.deviceStatusType')"
            required
            :clearable="true" />
        </v-col>

        <v-col 
          xl="6"
          lg="6"
          md="6"
          sm="6"
          cols="12">
          <v-select
            data-cy="deviceType"
            @change="updateFilter"
            v-model="filter.deviceType"
            :items="deviceTypes"
            value=""
            :label="$t('device.fields.deviceType')"
            required
            :clearable="true" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" justify="end" align="end">
          <v-btn @click="resetFilter" color="default" data-cy="resetDeviceFilterBtn">
            <v-icon small>
              refresh
            </v-icon>
            {{ $t('common.actions.reset') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </app-widget>
</template>

<script>
import AppWidget from '@/components/widgets/AppWidget';
import deviceTypesMixin from '@/mixins/deviceTypes.mixin';
import deviceStatusTypesMixin from '@/mixins/deviceStatusTypes.mixin';
import _ from 'lodash';

export default {
  name: 'DevicesFilter',
  props: {
    filter: Object
  },
  computed: {
    validationRules() {
      return {
        name: [
          v => (!v || v.length <= 50) || this.$t('validationMessages.device.name.maxLength', { maxLength: 50 }),
        ],
        imei: [
          v => (!v || v.length <= 20) || this.$t('validationMessages.device.imei.maxLength', { maxLength: 20 }),
        ]
      }
    }
  },
  created () {
    this.updateFilterDebounce = _.debounce($event => {
      this.$emit('updateFilter', this.filter);
    }, 500)
  },
  methods: {
    updateFilter () {
      this.$emit('updateFilter', this.filter);
    },
    resetFilter () {
      this.$emit('resetFilter');
    }
  },
  components: {
    AppWidget
  },
  mixins: [
    deviceTypesMixin,
    deviceStatusTypesMixin
  ]
}
</script>